/* ============================================================
   ra-terms-gate.js  —  required T&C acceptance gate
   ------------------------------------------------------------
   Keeps the [data-ra-terms] checkbox(es) on the cart page and
   cart drawer in sync, flips body[data-ra-terms-ok] (the CSS
   lock lives in ra-terms-gate.liquid), writes the acceptance
   to the cart so it lands on the order, and hard-blocks any
   checkout attempt until accepted. Event-delegated so it keeps
   working after Dawn re-renders the cart. ~1KB.
   ============================================================ */
(function () {
  function accepted() {
    var b = document.querySelector('[data-ra-terms]:checked');
    return !!b || document.body.getAttribute('data-ra-terms-ok') === '1';
  }
  function setOk(on) {
    if (on) document.body.setAttribute('data-ra-terms-ok', '1');
    else document.body.removeAttribute('data-ra-terms-ok');
    // keep every checkbox instance in sync
    document.querySelectorAll('[data-ra-terms]').forEach(function (c) {
      c.checked = on;
    });
  }
  function persist(on) {
    var body = {
      attributes: {
        terms_accepted: on ? 'yes' : '',
        terms_accepted_at: on ? new Date().toISOString() : ''
      }
    };
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).catch(function () {});
  }

  // Checkbox toggled (delegated — survives cart re-render)
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches('[data-ra-terms]')) return;
    var on = t.checked;
    setOk(on);
    persist(on);
  });

  // Hard backstop: block checkout submit/click if not accepted
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[name="checkout"], #checkout, #CartDrawer-Checkout, .shopify-payment-button button, .additional-checkout-buttons a, .additional-checkout-buttons button');
    if (t && !accepted()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var cb = document.querySelector('[data-ra-terms]');
      if (cb) { cb.focus(); }
    }
  }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if ((f.id === 'cart' || f.id === 'CartDrawer-Form') && !accepted()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var cb = document.querySelector('[data-ra-terms]');
      if (cb) { cb.focus(); }
    }
  }, true);
})();
